import { jsx, jsxs } from "react/jsx-runtime";
import { useClassNameFactory } from "@contember/react-utils";
import { memo } from "react";
import { Label } from "../Typography/Label.js";
import { toEnumViewClass } from "../../utils/toEnumViewClass.js";
import { Icon } from "../Icon/Icon.js";
const EditorBlockBoundary = memo(function EditorBlockBoundary2({ blockEdge, newParagraphText, onClick }) {
  const componentClassName = useClassNameFactory("editorBlockBoundary");
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: componentClassName(null, [
        toEnumViewClass(`${blockEdge}Block`)
      ]),
      contentEditable: false,
      "data-slate-editor": false,
      onClick,
      children: /* @__PURE__ */ jsxs("span", { className: componentClassName("inner"), children: [
        /* @__PURE__ */ jsx(Icon, { blueprintIcon: "add" }),
        /* @__PURE__ */ jsx(Label, { children: newParagraphText })
      ] })
    }
  );
});
export {
  EditorBlockBoundary
};
//# sourceMappingURL=EditorBlockBoundary.js.map
